// extracted by mini-css-extract-plugin
module.exports = {"header":"SectionHeader_header__svaFo","title":"SectionHeader_title__L3dSL","action":"SectionHeader_action__y5aWn"};